import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import backRed from "../../../../../assets/svg/back-rose-icon.svg";
import Breadcrumbs from "../../../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import SucessModal from "../../../../../components/Modal/SucessModal";
import "./form.scss";

const ExperienceForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const isViewMode = location.pathname.includes("-view");
  const isEditMode = location.pathname.includes("-edit");

  const [success, setSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      type: "",
      active: "true",
    },
  });

  useEffect(() => {
    if (id) {
      axios
        .get(`${process.env.REACT_APP_API_URL}experience/get/${id}`)
        .then((res) => {
          reset({
            type: res.data.type || "",
            active: res.data.active ? "true" : "false",
          });
        })
        .catch(() => alert("Error fetching data"));
    }
  }, [id, reset]);

  const onSubmit = (data) => {
    const payload = {
      ...data,
      active: data.active === "true",
    };

    const apiUrl = id
      ? `${process.env.REACT_APP_API_URL}experience/update/${id}`
      : `${process.env.REACT_APP_API_URL}experience/create`;

    const method = id ? "PATCH" : "POST";

    axios({ url: apiUrl, method, data: payload })
      .then(() => setSuccess(true))
      .catch(() => alert("Action failed"));
  };

  const breadcrumbsList = useMemo(
    () => [
      { text: "Masters", link: "/master-experience-create" },
      { text: "Common", link: "/master-experience" },
      { text: "experience", link: "" },
    ],
    [],
  );

  return (
    <>
      <Breadcrumbs
        className="w-75 healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      <div
        onClick={() => navigate("/master-experience")}
        className="rose back-button"
      >
        <img src={backRed} alt="Back" />
        <span className="rose-back">Back</span>
      </div>

      <div className="healtharticle">
        <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
          <div className="row car-dep-form">
            <div className="col-5">
              <label
                className="car-dep-form-txt mb-2"
                style={{ color: "#4B4853" }}
              >
                Experience <span className="star">*</span>
              </label>
              <input
                className="form-control w-75"
                type="text"
                {...register("type", { required: "Please enter gender." })}
                disabled={isViewMode}
              />
              {errors.type && (
                <div className="invalid-feedback d-block">
                  {errors.type.message}
                </div>
              )}
            </div>

            <div className="col-3">
              <label
                className="car-dep-form-txt mb-2"
                style={{ color: "#4B4853" }}
              >
                Active <span className="star">*</span>
              </label>
              <div className="d-flex">
                <div className="form-check form-check-inline align-items-center">
                  <input
                    className="form-check-input me-3"
                    type="radio"
                    value="true"
                    {...register("active", {
                      required: "Please select active status.",
                    })}
                    disabled={isViewMode}
                    id="activeTrue"
                  />
                  <label htmlFor="activeTrue" className="text-dark">
                    Active
                  </label>
                </div>
                <div className="form-check form-check-inline align-items-center">
                  <input
                    className="form-check-input me-3"
                    type="radio"
                    value="false"
                    {...register("active", {
                      required: "Please select active status.",
                    })}
                    disabled={isViewMode}
                    id="activeFalse"
                  />
                  <label htmlFor="activeFalse" className="text-dark">
                    Inactive
                  </label>
                </div>
              </div>
              {errors.active && (
                <div className="invalid-feedback d-block">
                  {errors.active.message}
                </div>
              )}
            </div>
          </div>

          <div className="car-dep-form-button">
            {!isViewMode && (
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                {id ? "Update" : "Submit"}
              </button>
            )}
          </div>
        </form>
      </div>

      {success && (
        <SucessModal
          page={"/master-experience"}
          name="experience"
          post={isEditMode ? "updated" : "posted"}
        />
      )}
    </>
  );
};

export default ExperienceForm;
